<template>
    <el-dialog :visible.sync="modals"
            style="z-index: 10002;"
            title="选择链接"
            width="1000px"
            :z-index="10002"
            :before-close="closeDialog">
        <div class="table_box">
            <div class="left_box">
                <el-tree :default-expand-all="true" :data="categoryData" :props="{
                    children: 'children',
                    label: 'name',
                }" @node-click="handleCheckChange"></el-tree>
            </div>
            <div class="right_box" v-if="currenType == 'link'">
                <div v-if="basicsList.length">
                    <div class="cont">基础链接</div>
                    <div class="Box">
                        <div class="cont_box" :class="currentId==item.url ? 'on':''" v-for="(item,index) in basicsList"
                             :key="index" @click="getUrl(item)">{{item.name}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="right_box" v-if="currenType == 'category'">
                <el-table class="table" type="expand" ref="singleTable" :data="tableList"  border style="width: 100%" :empty-text="'无数据'">
                    <el-table-column width="55" >
                        <template #default="{row, index}">
                            <el-radio class="radio" v-model="currentId" :label="row.id" :name="''" @click.native.prevent="singleClickData(row)"></el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" label="ID" width="80" align="center"/>
                    <el-table-column prop="name" label="分类名称" min-width="250" align="center"/>
                </el-table>
            </div>
            <div class="right_box" v-if="currenType == 'goods'">
                <el-table class="table" type="expand" ref="singleTable" :data="tableList"  border style="width: 100%" :empty-text="'无数据'">
                    <el-table-column width="55" >
                        <template #default="{row, index}">
                            <el-radio class="radio" v-model="currentId" :label="row.id" :name="''" @click.native.prevent="singleClickData(row)"></el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" label="ID" width="80" align="center"/>
                    <el-table-column prop="name" label="商品名称" min-width="250" align="center"/>
                </el-table>
                <el-pagination
                        :current-page="formValidate.page"
                        :page-size="formValidate.pagesize"
                        :total="total"
                        :background="true"
                        goto="'前往'"
                        @current-change="pageCurrentChange"
                        class="ele-pagination-circle"/>
            </div>
            <div class="right_box" v-if="currenType == 'seckill'">
                <el-table class="table" type="expand" ref="singleTable" :data="tableList"  border style="width: 100%" :empty-text="'无数据'">
                    <el-table-column width="55" >
                        <template #default="{row, index}">
                            <el-radio class="radio" v-model="currentId" :label="row.active_id" :name="''" @click.native.prevent="singleClickData(row)"></el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="active_id" label="ID" width="80" align="center"/>
                    <el-table-column label="商品名称" min-width="250" align="center">
                        <template #default="{row, index}">
                           {{row.goods.name}}
                        </template>
                    </el-table-column>
                    <el-table-column label="开始时间" width="150" align="center">
                        <template #default="{row, index}">
                            {{ row.start_time | formatDate }}
                        </template>
                    </el-table-column>
                    <el-table-column label="结束时间" width="150" align="center">
                        <template #default="{row, index}">
                            {{ row.end_time | formatDate }}
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        :current-page="formValidate.page"
                        :page-size="formValidate.pagesize"
                        :total="total"
                        :background="true"
                        goto="'前往'"
                        @current-change="pageCurrentChange"
                        class="ele-pagination-circle"/>
            </div>
            <div class="right_box" v-if="currenType == 'help'">
                <el-table class="table" type="expand" ref="singleTable" :data="tableList"  border style="width: 100%" :empty-text="'无数据'">
                    <el-table-column width="55" >
                        <template #default="{row, index}">
                            <el-radio class="radio" v-model="currentId" :label="row.id" :name="''" @click.native.prevent="singleClickData(row)"></el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" label="ID" width="80" align="center"/>
                    <el-table-column prop="title" label="标题" min-width="250" align="center"/>
                </el-table>
                <el-pagination
                        :current-page="formValidate.page"
                        :page-size="formValidate.pagesize"
                        :total="total"
                        :background="true"
                        goto="'前往'"
                        @current-change="pageCurrentChange"
                        class="ele-pagination-circle"/>
            </div>
        </div>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="ok" v-if="currenType == 'custom'">确定</el-button>
                <el-button type="primary" @click="ok" v-else>确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
    import {getLink, categoryList, helpList} from "@/api/diy";
    import { formatDate } from "@/utils/validate";

    export default {
        name: "index",
        filters: {
            formatDate(time) {
                if (time !== 0) {
                    let date = new Date(time * 1000);
                    return formatDate(date, "yyyy-MM-dd hh:mm");
                }
            },
        },
        data() {
            return {
                modals: false,
                categoryData: [],
                currenType: 'link',
                basicsList: [],
                currentId: 0,
                currentUrl: '',

                customdate: {
                    url:''
                },
                tableList: [],
                formValidate: {
                    page: 1,
                    pagesize: 15,
                    store_category_id: "",
                    name: "",
                    is_new: this.is_new,
                },
            }
        },
        created() {
            this.getSort()
        },
        methods: {
            closeDialog: function () {
                this.modals = false
            },
            getUrl(item){
                this.currentId = item.url;
                this.currentUrl = item.url;
            },
            getSort() {
                getLink().then(res => {
                    if (res.code == 1) {
                        res.data[0].children[0].selected = true;
                        this.categoryData = res.data;
                        this.handleCheckChange(res.data[0].children[0]);
                    }
                })
            },
            singleClickData: function (row) {
                switch (this.currenType) {
                    case 'category':
                        this.currentId = row.id
                        break;
                    case 'goods':
                        this.currentId = row.goods_id
                        break;
                    case 'seckill':
                        this.currentId = row.active_id
                        break;
                }

                this.currentUrl = row.url;
            },
            pageCurrentChange(val) {
                this.formValidate.page = val
                this.getList()
            },
            handleCheckChange(event) {
                this.currenType = event.type
                let _data = event.links;

                if (event.type == 'link') {
                    let basicsList = [];
                    _data.forEach((e) => {
                        if (e.type == 0) {
                            basicsList.push(e)
                        }
                    });
                    this.basicsList = basicsList;
                } else if (event.type == 'category') {
                    categoryList({}).then(async res => {
                        if (res.code == 1) {
                            let data = res.data.list
                            data.forEach((e) => {
                                e.url = `/pages/search-store/search-store?id=${e.id}`
                            });
                            this.tableList = data
                        }
                    })
                } else if (event.type == 'goods') {
                    this.getList();
                } else if (event.type == 'seckill') {
                    this.getList();
                } else if (event.type == 'help') {
                    helpList({}).then(async res => {
                        if (res.code == 1) {
                            let data = res.data.list
                            data.forEach((e) => {
                                e.url = `/pages/help/detail?id=${e.help_id}`
                            });
                            this.tableList = data
                        }
                    })
                }
            },
            getList: function () {
                if (this.currenType == 'goods') {
                    this.getGoodsList()
                } else if (this.currenType == 'seckill') {
                    this.getSeckillList()
                }
            },
            getGoodsList: function () {
                this.axios.post('store/goods/list', this.formValidate)
                .then(async (res) => {
                    if (res.code == 1) {
                        let data = res.data.list;
                        data.data.forEach((e) => {
                            e.url = `/pages/goods/goods?id=${e.goods_id}`
                        });
                        this.tableList = data.data;
                        this.total = data.total;
                        this.loading = false;
                    }
                })
                .catch((res) => {
                    this.loading = false;
                    this.$Message.error(res.msg);
                });
            },
            getSeckillList: function () {
                this.axios.post('store/app.seckill.active/list', this.formValidate)
                    .then(async (res) => {
                        if (res.code == 1) {
                            let data = res.data.list;
                            data.data.forEach((e) => {
                                e.url = `/app/seckill/goods/index?active_id=${e.active_id}`
                            });
                            this.tableList = data.data;
                            this.total = data.total;
                            this.loading = false;
                        }
                    })
                    .catch((res) => {
                        this.loading = false;
                        this.$Message.error(res.msg);
                    });
            },
            reset(){
                this.currentUrl = "";
                this.currentId = "";
                this.customdate.url="";
            },
            ok(){
                if(this.currentUrl == ""){
                    return this.$message.warning("请选择链接");
                }else {
                    this.$emit("linkUrl",this.currentUrl);
                    this.modals = false
                    this.reset();
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .tabBox_img {
        width: 36px;
        height: 36px;
        border-radius: 4px;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
        }
    }

    /*定义滑块 内阴影+圆角*/
    ::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px #ddd;
    }

    ::-webkit-scrollbar {
        width: 4px !important; /*对垂直流动条有效*/
    }

    .on {
        background-color: #2d8cf0 !important;
        color: #fff !important;
    }

    .menu-item {
        position: relative;
        display: flex;
        justify-content: space-between;
        word-break: break-all;

        .icon-box {
            z-index: 3;
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            display: none;
        }

        &:hover .icon-box {
            display: block;
        }

        .right-menu {
            z-index: 10;
            position: absolute;
            right: -106px;
            top: -11px;
            width: auto;
            min-width: 121px;
        }
    }

    .table_box {
        margin-top: 14px;
        display: flex;
        position: relative;

        .left_box {
            width: 171px;
            height: 470px;
            border-right: 1px solid #EEEEEE;
            overflow-x: hidden;
            overflow-y: auto;

            .left_cont {
                margin-bottom: 12px;
                cursor: pointer;
            }
        }

        .right_box {
            margin-left: 23px;
            font-size: 13px;
            width: 645px;
            height: 470px;
            overflow-x: hidden;
            overflow-y: auto;

            .cont {
                font-weight: 500;
                color: #000000;
                font-weight: bold;
            }

            .Box {
                margin-top: 19px;
                display: flex;
                flex-wrap: wrap;

                .cont_box {
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.85);
                    background: #FAFAFA;
                    border-radius: 3px;
                    text-align: center;
                    padding: 7px 30px;
                    margin-right: 10px;
                    margin-bottom: 18px;
                    cursor: pointer;

                    &:hover {
                        background-color: #eee;
                        color: #333;
                    }
                }

                .item {
                    position: relative;

                    .iconfont {
                        display: none;
                    }

                    &:hover {
                        .iconfont {
                            display: block;
                        }
                    }
                }

                .iconfont {
                    position: absolute;
                    right: 9px;
                    top: -8px;
                    font-size: 18px;
                    color: #333;
                }
            }

        }

        .Button {
            position: absolute;
            bottom: 15px;
            right: 15px;
            text-align: center;
            .cancel {
                width: 70px;
                height: 32px;
                background: #FFFFFF;
                border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
                border-radius: 2px;
                font-size: 14px;
                color: #000000;
                line-height: 32px;
                float: left;
                margin-right: 10px;
                cursor: pointer;
            }

            .ok {
                width: 70px;
                height: 32px;
                background: #1890FF;
                border-radius: 2px;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 32px;
                float: left;
                cursor: pointer;
            }
        }
    }

    .table ::v-deep {
        .el-radio.radio {
            .el-radio__label {
                display: none;
            }
        }
    }
</style>
